import ReactDOM from 'react-dom';
import DashboardApp from './App';

import "./App.less";

export default {
  init(opts: any) {
    ReactDOM.render(<DashboardApp />, document.querySelector(opts.container))
  }
};